import type { ReactNode } from 'react';
import InfoSection from '@/components/Approval/@components/InfoSection';
import { InfoTableEmphasis, InfoTableRoot } from './styles';

export { InfoTableEmphasis, InfoTableRoot } from './styles';

export type InfoTableRow = {
  label: string;
  value: ReactNode;
  emphasis?: boolean;
};

type InfoTableProps = {
  title?: ReactNode;
  rows: InfoTableRow[];
  /** 라벨 열 폭. CSS width 값 */
  labelWidth?: string;
};

/** 전자결재 조회 본문의 라벨 / 값 2열 정보 표. title 이 있으면 InfoSection 으로 감쌈 */
const InfoTable = ({ title, rows, labelWidth = '30%' }: InfoTableProps) => (
  <InfoSection title={title}>
    <InfoTableRoot>
      <colgroup>
        <col style={{ width: labelWidth }} />
        <col />
      </colgroup>
      <tbody>
        {rows.map((row) => (
          <tr key={row.label}>
            <th scope="row">{row.label}</th>
            <td>
              {row.emphasis ? (
                <InfoTableEmphasis>{row.value}</InfoTableEmphasis>
              ) : (
                row.value
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </InfoTableRoot>
  </InfoSection>
);

export default InfoTable;
